{
  "actions": {
    "add_contact_to_list": "Ajouter un contact à cette liste",
    "add_to_list": "Ajouter à la liste",
    "edit_custom_fields": "Modifier les champs personnalisés",
    "bulk_edit_custom_fields": "Modification en lot des champs personnalisés",
    "remove_list": "Supprimer la liste",
    "add_contact": "Ajouter un contact"
  },
  "confirmations": {
    "archive_list": "Êtes-vous sûr de vouloir archiver cette liste ?"
  },
  "errors": {
    "failed_to_create_contact": "Échec de la création de ce contact"
  },
  "more_actions": {
    "removed_history": "Historique des suppressions",
    "list_settings": "Paramètres de la liste",
    "manage_columns": "Gérer les colonnes",
    "reminder": "Rappel",
    "add_comment": "Ajouter un commentaire",
    "api_connections": "Connexions API"
  },
  "lists": {
    "name_required": "Veuillez saisir un nom de liste",
    "create_list": "Créer une liste",
    "name": "Nom",
    "rename": "Renommer la liste",
    "new_contact_list": "Nouvelle liste de contacts",
    "enable_duplicate_contacts": "Activer les contacts en double",
    "duplicate_contacts_tooltip": "Activer les contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation des données peuvent ne pas fonctionner correctement.",
    "more_actions": {
      "request_contacts": "Demander des contacts",
      "clean_list": "Nettoyer la liste",
      "connected_to": "Connecté à",
      "sync_with": "Synchroniser avec"
    },
    "remove_from_contact_list_multiple": "Ces contacts seront supprimés de cette liste."
  },
  "company_list": {
    "shared_company_list": "liste d'entreprises partagée",
    "personal_company_list": "liste d'entreprises personnelle",
    "project_company_list": "liste d'entreprises de projet",
    "list_memberships": "Listes",
    "import_companies": "Importer des entreprises",
    "add_company": "Ajouter une entreprise",
    "add_to_list": "Ajouter à la liste",
    "edit_company_type": "Modifier le type d'entreprise",
    "bulk_edit": "Modification en lot",
    "remove": "Supprimer",
    "list": "Liste",
    "company": "Entreprise",
    "add_company_to_list": "Ajouter une entreprise à la liste",
    "bulk_edit_custom_fields": "Modification en lot des champs personnalisés",
    "edit_custom_fields": "Modifier les champs personnalisés",
    "please_select_company": "Veuillez sélectionner une entreprise à ajouter à cette liste",
    "please_choose_list": "Veuillez choisir une liste",
    "which_company_placeholder": "Quelle entreprise voulez-vous ajouter à cette liste",
    "action_cannot_be_undone": "Cette action ne peut pas être annulée",
    "delete_tab_confirmation": "Êtes-vous sûr de vouloir supprimer cet onglet ?",
    "company_removed_from_list": "L'entreprise sera supprimée de cette liste.",
    "remove_company_confirmation": "Êtes-vous sûr de vouloir supprimer l'entreprise de cette liste ?",
    "remove_company_aria_label": "supprimer l'entreprise de cette liste",
    "loading_companies": "chargement des entreprises",
    "more_companies_contact_support": "Il y a plus d'entreprises que celles affichées. Veuillez contacter le support NEXL.",
    "grid": {
      "columns": {
        "company": "Entreprise",
        "open_tasks": "Tâches ouvertes",
        "last_updated": "Dernière mise à jour",
        "company_domain": "Domaine de l'entreprise",
        "location": "Localisation",
        "contact_count": "Nombre de contacts",
        "number_of_employees": "Nombre d'employés",
        "relationship_partner": "Associé(s) relationnel",
        "type": "Type",
        "engagement": "Engagement",
        "last_interaction": "Dernière interaction",
        "last_meeting": "Dernière réunion",
        "last_sent_email_at": "Dernier courriel envoyé le",
        "last_received_email_at": "Dernier courriel reçu le",
        "last_bd_interaction_at": "Dernière interaction BD le",
        "last_marketing_interaction_at": "Dernière interaction marketing le",
        "number_of_interactions": "Nombre d'interactions",
        "number_of_meetings": "Nombre de réunions",
        "number_of_sent_emails": "Nombre de courriels envoyés",
        "number_of_received_emails": "Nombre de courriels reçus",
        "number_of_total_emails": "Nombre total de courriels",
        "tags": "Tags",
        "industry_names": "Noms d'industrie",
        "internal_industry_names": "Noms d'industrie interne",
        "website": "Site web",
        "linkedin_url": "URL LinkedIn",
        "twitter_url": "URL Twitter",
        "correspondence_numbers": "Numéros de correspondance",
        "correspondence_emails": "Courriels de correspondance",
        "client_id": "ID client",
        "group_id": "ID de groupe",
        "edit": "Modifier"
      }
    }
  },
  "my_lists": {
    "page": {
      "create_list": "Créer une liste",
      "search_placeholder": "Rechercher des listes...",
      "lists_header": "Listes"
    },
    "empty_states": {
      "no_shared_list": "Aucune liste partagée",
      "your_list_is_empty": "Votre liste est vide",
      "no_lists_found": "Aucune liste trouvée",
      "no_search_results": "Nous n'avons trouvé aucune liste correspondant à votre recherche. Essayez d'utiliser des mots-clés différents ou créez une nouvelle liste",
      "list_not_found": "Liste introuvable"
    },
    "table": {
      "columns": {
        "name": "Nom",
        "location": "Emplacement",
        "created_at": "Créé le",
        "created_by": "Créé par",
        "last_viewed": "Dernière consultation",
        "actions": "Actions"
      }
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "list_actions": "Actions de liste",
      "rename_list": "Renommer la liste",
      "share_list": "Partager la liste",
      "add_company": "Ajouter une entreprise",
      "add_contact": "Ajouter un contact",
      "add_generic_item": "Ajouter un élément",
      "add_activity": "Ajouter une activité",
      "add_column": "Ajouter une colonne",
      "share": "Partager"
    },
    "forms": {
      "list_name": "Nom de la liste",
      "list_name_required": "Veuillez saisir un nom de liste",
      "invite": "Inviter",
      "invitee_required": "Veuillez choisir au moins un invité",
      "enable_duplicate_contacts": "Autoriser les contacts en double",
      "duplicate_contacts_tooltip": "L'activation des contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation de données peuvent ne pas fonctionner correctement."
    },
    "confirmations": {
      "archive_list_title": "Archiver la liste ?",
      "archive_list_content": "Êtes-vous sûr de vouloir archiver cette liste ? Elle sera supprimée de la liste.",
      "remove_user_title": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      "remove_user_content": "Cliquez sur confirmer pour supprimer"
    },
    "share": {
      "invite_tab": "Inviter",
      "access_tab": "Accès",
      "owner": "Propriétaire",
      "success_message": "Votre liste a été partagée avec succès. Nous informerons les destinataires.",
      "loading_users": "Chargement des utilisateurs"
    },
    "scopes": {
      "all": {
        "name": "Rechercher des listes",
        "description": "Recherchez une liste à laquelle vous avez accès ou sélectionnez parmi vos listes récemment consultées."
      },
      "created": {
        "name": "Créé par moi",
        "description": "Voici vos éléments récemment créés. Utilisez la recherche pour en trouver d'autres et restez organisé en suivant votre travail."
      },
      "shared": {
        "name": "Partagé avec moi",
        "description": "Recherchez pour trouver une liste ou sélectionnez parmi une de vos listes récentes partagées avec vous."
      },
      "workspace": {
        "name": "Listes d'espace de travail",
        "description": ""
      },
      "app": {
        "name": "Listes d'applications",
        "description": ""
      },
      "marketing": {
        "name": "Listes marketing",
        "description": ""
      }
    },
    "navigation": {
      "other_lists": "Autres listes"
    },
    "types": {
      "contact_list": "Créer une liste de contacts pour votre projet",
      "company_list": "Créer une liste d'entreprises pour votre projet",
      "generic_list": "Créer une liste personnalisée pour soutenir votre projet"
    },
    "empty_descriptions": {
      "shared": "Il semble que personne n'ait encore partagé de listes avec vous. Quand quelqu'un partage une liste, elle apparaîtra ici.",
      "marketing": "Commencez à créer votre liste sur Marketing pour les voir ici.",
      "app": "Commencez à créer votre liste sur Apps pour les voir ici.",
      "workspace": "Commencez à créer votre liste sur Workspace pour les voir ici.",
      "default": "Commencez à créer votre liste pour les voir ici."
    }
  },
  "company_list_grid": {
    "add_company": "Ajouter une entreprise",
    "add_to_list": "Ajouter à la liste",
    "edit_company_type": "Modifier le type d'entreprise",
    "bulk_edit": "Modification en lot",
    "remove": "Supprimer",
    "import_companies": "Importer des entreprises"
  },
  "removed_history": {
    "title": "Historique des suppressions",
    "empty_state": {
      "title": "Aucun contact supprimé",
      "description": "Aucun contact n'a encore été supprimé de cette liste. Une fois les contacts supprimés, ils apparaîtront ici."
    },
    "table": {
      "selected_count": "{{count}} sélectionné(s)",
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "removed_date": "Date de suppression",
        "removed_by": "Supprimé par"
      }
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "go_back_tooltip": "retourner à {{listName}}"
    }
  },
  "e_marketing_integration": {
    "settings": {
      "title": "Paramètres eMarketing",
      "sync_to_tools": "Synchroniser avec les outils eMarketing",
      "sync_to_tools_caption": "Chaque fois que vous synchronisez avec un outil eMarketing, une nouvelle liste sera créée dans leur application. Vous pouvez choisir quels champs mapper, en vous assurant que les bonnes données sont incluses."
    },
    "sync": {
      "title": "Synchroniser les contacts",
      "save_and_sync": "Sauvegarder et synchroniser",
      "connector_name": "Nom du connecteur",
      "e_marketing_list_name": "Nom de la liste eMarketing",
      "e_marketing_list_name_caption": "Si une liste avec le même nom existe dans l'outil eMarketing, elle sera écrasée.",
      "type_connector_name": "Tapez le nom du connecteur",
      "select_connector": "Sélectionner le connecteur",
      "syncing_tooltip": "La synchronisation des contacts avec l'outil eMarketing est en cours.",
      "syncing_status": "Synchronisation..."
    },
    "status": {
      "out_of_sync_title": "Liste non synchronisée.",
      "sync_now": "Synchroniser maintenant",
      "sync_now_description": "pour mettre à jour vos données.",
      "sync_complete_title": "Synchronisation terminée :",
      "sync_complete_description": "Votre liste de contacts a été synchronisée avec",
      "sync_complete_on": "le",
      "sync_failed_title": "Échec de la synchronisation :",
      "sync_failed_description": "Cela peut être dû à des problèmes de connexion ou à des paramètres incorrects. Ouvrez",
      "e_marketing_setup": "configuration eMarketing",
      "retry_description": "pour réessayer."
    },
    "disconnect": {
      "title": "Supprimer la connexion ?",
      "description": "Êtes-vous sûr de vouloir supprimer cette connexion ? Cette action supprimera l'intégration et toutes les synchronisations en cours seront arrêtées. Cette action ne peut pas être annulée.",
      "aria_label": "Supprimer la connexion",
      "button_title": "Supprimer la connexion"
    },
    "field_mapping": {
      "title": "Champs à mapper",
      "nexl_fields": "Champs Nexl",
      "concep_fields": "Champs Concep",
      "add_map_field": "Ajouter un champ de mappage",
      "select_nexl_field": "Sélectionner le champ Nexl",
      "select_remote_field": "Sélectionner le champ distant",
      "remove_field_mapping": "Supprimer le mappage de champ {{index}}"
    }
  },
  "list_cleaner": {
    "status_result": "Résultat du statut",
    "last_verified": "Dernière vérification",
    "verify_list": {
      "button": "Vérifier la liste",
      "verifying": "Vérification de la liste",
      "confirmation_title": "Vérifier la liste",
      "confirmation_content": "Validez les adresses courriel pour leur exactitude avant d'envoyer des campagnes."
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "location": "Localisation",
        "last_interaction": "Dernière interaction",
        "consent_status": "Statut de consentement",
        "reason": "Raison",
        "result": "Résultat",
        "status": "Statut",
        "action": "Action"
      },
      "selected_count": "{{count}} sélectionné(s)"
    },
    "actions": {
      "mark_as_low_risk": "Marquer comme faible risque",
      "remove_from_list": "Supprimer de la liste",
      "list_cleaner_actions": "actions de nettoyage de liste"
    },
    "contact_status": {
      "bounced": "Supprimer les rebonds",
      "consent_not_given": "Supprimer de la liste",
      "total": "Supprimer de la liste",
      "unengaged": "Supprimer les non-engagés",
      "user_unsubscribed": "Supprimer les désabonnés"
    },
    "status_labels": {
      "bounced": "Rebondis",
      "consent_not_given": "Consentement non donné",
      "total": "Total",
      "unengaged": "Non-engagés",
      "user_unsubscribed": "Utilisateur désabonné"
    },
    "risk": {
      "high_risk": "Risque élevé",
      "medium_risk": "Risque moyen",
      "low_risk": "Faible risque",
      "unknown_risk": "Risque inconnu",
      "risk_with_level": "{{level}} RISQUE",
      "tooltips": {
        "high": "L'envoi à cette adresse très risquée nuira à votre réputation.",
        "medium": "Il s'agit de notre niveau de risque neutre. Les courriels non classés comme risque faible ou élevé sont par défaut à risque moyen.",
        "low": "L'adresse courriel est probablement valide et l'envoi présente un faible risque pour votre réputation."
      }
    },
    "confirmations": {
      "mark_low_risk_title": "Marquer comme faible risque ?",
      "mark_low_risk_content": "Les contacts marqués comme à haut risque sont ignorés des campagnes. Marquer le contact comme à faible risque déclenchera la livraison de la campagne au contact.\n\nSi l'e-mail est à nouveau validé dans les 3 prochains mois, le statut à faible risque sera préservé. Passé ce délai, si le contact est revalidé, Risk Status sera actualisé.",
      "remove_from_list_title": "Supprimer de la liste ?",
      "remove_from_list_single": "Ce contact sera supprimé de votre liste.",
      "remove_from_list_multiple": "Ces contacts seront supprimés de votre liste.",
      "remove_all_contacts_title": "Supprimer tous les contacts {{type}} de la liste ?",
      "remove_all_contacts_content": "Ces contacts seront supprimés de votre liste."
    },
    "success": {
      "contacts_cleaned_title": "Contacts {{type}} nettoyés !",
      "contacts_cleaned_description": "Tous les contacts {{type}} ont été supprimés. Votre liste est maintenant plus efficace et livrable !"
    },
    "remove_cleaned": {
      "ok": "Ok"
    }
  },
  "contact_list_grid": {
    "actions": {
      "add_contact": "Ajouter un contact",
      "import_contacts": "Importer des contacts",
      "export": "Exporter",
      "refresh": "Actualiser",
      "share": "Partager",
      "sync_contacts": "Synchroniser les contacts",
      "syncing": "Synchronisation",
      "add_tags": "Ajouter des Tags",
      "bulk_edit": "Modification en lot",
      "log_new_activity": "Enregistrer une nouvelle activité"
    },
    "sync": {
      "failed": "Échec de la synchronisation",
      "try_again": "Réessayer",
      "out_of_sync": "Liste non synchronisée. Synchronisez maintenant pour mettre à jour vos données.",
      "complete": "Synchronisation terminée : Votre liste de contacts a été synchronisée avec {{campaignManagerName}} !",
      "in_progress": "Synchronisation de la liste, cela peut prendre quelques minutes..."
    },
    "status": {
      "loading_contacts_aria": "chargement des contacts",
      "error_prefix": "Erreur : {{message}}",
      "over_limit": "Cette liste dépasse la limite, affichage de {{count}} seulement.",
      "outdated_list": "La liste que vous consultez est obsolète, cliquez sur actualiser pour voir les dernières modifications."
    },
    "tooltips": {
      "duplicate_contacts": "L'activation des contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation de données peuvent ne pas fonctionner correctement."
    }
  },
  "expiry": {
    "description": "Définir une condition pour fermer automatiquement les soumissions de formulaire.",
    "enable_label": "Activer la date d'expiration",
    "date_label": "Date d'expiration",
    "date_placeholder": "Quand le formulaire expirera-t-il ?",
    "page_header_label": "En-tête de la page d'expiration",
    "page_header_placeholder": "Veuillez saisir l'en-tête de la page d'expiration",
    "page_description_label": "Description de la page d'expiration",
    "default_header": "Le formulaire a expiré",
    "default_description": "Ce formulaire a expiré et ne peut plus être consulté. Veuillez contacter le propriétaire du formulaire pour obtenir de l'aide.",
    "validation": {
      "date_required": "Veuillez sélectionner une date d'expiration",
      "date_past": "La date et l'heure ne peuvent pas être dans le passé",
      "header_required": "Veuillez saisir l'en-tête de la page d'expiration"
    }
  },
  "views": {
    "default_view": "Vue par défaut",
    "views_label": "Vues",
    "create_view": "Créer une vue",
    "edit_view": "Modifier la vue",
    "delete_view": "Supprimer la vue",
    "share_view": "Partager la vue",
    "view_name_label": "Nom de la vue",
    "view_actions_aria": "actions de vue pour {{viewName}}",
    "select_view_aria": "Sélectionner la vue {{viewType}}",
    "choose_single_select_column": "Choisir une colonne de sélection unique",
    "choose_column": "Choisir une colonne",
    "single_select_tooltip": "Fait référence à un type de champ qui permet aux utilisateurs de choisir une seule option parmi un ensemble d'options prédéfinies",
    "view_types": {
      "list": "Liste",
      "board": "Tableau",
      "calendar": "Calendrier",
      "timeline": "Chronologie",
      "unknown": "{{new_type}}"
    },
    "list": {
      "description": "Organisez les informations dans un tableau. Idéal pour avoir un aperçu de tous les contacts, tâches, Tags, assignés et dates d'échéance."
    },
    "board": {
      "description": "Visualisez vos données dans un tableau. Nécessite un champ de sélection unique."
    },
    "calendar": {
      "description": "Consultez vos données dans un calendrier. Nécessite au moins un champ de date."
    },
    "timeline": {
      "description": "Visualisez vos données dans une chronologie. Nécessite au moins un champ de date."
    },
    "permissions": {
      "read_only": "Lecture seule",
      "edit_description": "Autorisé à modifier la liste et ajouter de nouveaux contacts",
      "read_only_description": "Autorisé à voir la liste et les détails des contacts mais ne peut pas apporter de modifications",
      "anyone_can_edit": "Toute personne avec le lien peut modifier",
      "anyone_can_view": "Toute personne avec le lien peut voir",
      "anyone_can_read_only": "Toute personne avec le lien peut voir en lecture seule"
    },
    "share": {
      "share_view_title": "Partager la vue",
      "item_label": "Élément",
      "permission_label": "Permission",
      "copy_link": "Copier le lien",
      "link_copied": "Lien copié !",
      "invite_member": "Inviter un membre",
      "link_copied_tooltip": "Lien copié !",
      "copy_link_description": "Entrez l'courriel ou le nom de l'utilisateur pour partager une vue, ou copiez",
      "this_link": "ce lien",
      "to_share": "pour partager",
      "copy_link_aria": "copier ce lien pour partager",
      "success_message": "La vue de liste a été partagée avec succès. Nous informerons les destinataires.",
      "create_new_view_message": "Créer une nouvelle vue à partager",
      "invite_required": "Veuillez inviter au moins un membre"
    },
    "confirmations": {
      "delete_content": "Cliquez sur confirmer pour supprimer la vue"
    },
    "validation": {
      "name_required": "Veuillez saisir un nom"
    }
  },
  "all_or_my_external_filter": {
    "all": "Tout",
    "my_contacts": "Mes contacts",
    "all_contacts_aria": "Afficher tous les contacts",
    "my_contacts_aria": "Afficher mes contacts",
    "my_companies": "Mes entreprises",
    "all_companies_aria": "Afficher toutes les entreprises",
    "my_companies_aria": "Afficher mes entreprises"
  },
  "generic_list": {
    "slide": {
      "preview": "Aperçu",
      "overview": "Vue d'ensemble",
      "tasks": "Tâches"
    },
    "actions": {
      "create_row": "Créer une ligne",
      "import_items": "Importer des éléments",
      "edit_row": "modifier la ligne",
      "open_slide": "ouvrir le panneau"
    },
    "forms": {
      "new_row": "Nouvelle ligne",
      "edit_row": "Modifier la ligne",
      "bulk_edit_rows": "Modification en lot des lignes"
    },
    "status": {
      "over_limit": "Il y a plus d'éléments que ceux affichés. Veuillez contacter le support NEXL.",
      "loading_items": "chargement des éléments"
    },
    "confirmations": {
      "remove_rows_one": "Veuillez confirmer que vous voulez supprimer cette ligne",
      "remove_rows_other": "Veuillez confirmer que vous voulez supprimer ces lignes"
    }
  },
  "forms": {
    "link_campaign": {
      "title": "Lier la campagne à un formulaire",
      "description": "Obtenez le lien du formulaire à ajouter à votre campagne",
      "button": "Lier le formulaire",
      "generating": "Génération de l'URL",
      "no_url_error": "Aucune URL trouvée. Veuillez contacter le support."
    },
    "prefill": {
      "label": "Pré-remplir les champs du formulaire",
      "tooltip": "Lorsque activé, les informations de contact de votre campagne rempliront automatiquement les champs du formulaire"
    },
    "form_selection": {
      "label": "Formulaire",
      "placeholder": "Veuillez sélectionner un formulaire",
      "generate_link": "Générer le lien"
    },
    "add": {
      "title": "FORMULAIRE",
      "label": "Formulaire",
      "button": "Ajouter un formulaire",
      "contact_list_form": "Formulaire de liste de contacts"
    },
    "empty": {
      "message": "Commencez à créer un nouveau formulaire ici."
    },
    "rename": {
      "placeholder": "Entrez le nom du formulaire"
    },
    "sync": {
      "stats_button": "Synchroniser les statistiques",
      "working_message": "Nous travaillons sur ceci, veuillez revenir dans quelques minutes et actualiser la page..."
    },
    "actions": {
      "edit": "Modifier",
      "rename": "Renommer",
      "copy_link": "Copier le lien du formulaire pour EMS"
    },
    "delete": {
      "confirmation": "Êtes-vous sûr de vouloir supprimer ce formulaire ?",
      "title": "Supprimer le formulaire",
      "button": "Supprimer"
    },
    "status": {
      "expired": "Expiré",
      "draft": "Brouillon",
      "unpublished_changes": "Modifications non publiées",
      "published": "Publié"
    },
    "preview": {
      "loading": "Chargement du formulaire...",
      "redirecting": "Redirection...",
      "required_fields_empty": "Les champs obligatoires sont vides",
      "submit": "Soumettre",
      "supported_by": "Pris en charge par",
      "display_not_supported": "Affichage non pris en charge"
    },
    "contact_label": "Contact",
    "contact_placeholder": "Quel contact voulez-vous fusionner",
    "email_placeholder": "Saisissez l'adresse courriel",
    "new_contact_header": "Nouveau contact",
    "list_label": "Liste",
    "please_choose_list": "Veuillez choisir une liste"
  },
  "share": {
    "read_only_badge": "Lecture seule",
    "list_not_found": {
      "title": "Cette page n'est pas disponible",
      "description": "Désolé, la page que vous essayez d'accéder est introuvable. Veuillez contacter le propriétaire pour obtenir de l'aide.",
      "go_to_nexl": "Aller à nexl"
    },
    "header": {
      "powered_by": "Propulsé par",
      "go_to_home_alt": "aller à l'accueil"
    }
  },
  "remove_list_member": {
    "confirm_title": "Êtes-vous sûr de vouloir supprimer le contact de cette liste ?",
    "confirm_content": "Le contact sera supprimé de cette liste."
  },
  "key_activity_list": {
    "actions": {
      "add_activity": "Ajouter une activité",
      "open_slide_aria_prefix": "ouvrir le panneau pour l'activité clé :",
      "open_slide_title": "ouvrir le panneau d'activité clé",
      "update_activity_aria": "modifier l'activité clé",
      "update_activity_title": "modifier l'activité clé",
      "remove_activity_aria_prefix": "supprimer l'activité clé",
      "remove_activity_title": "supprimer l'activité clé",
      "edit_custom_fields": "Modifier les champs personnalisés"
    },
    "add_to_list": {
      "modal_header": "Ajouter à la liste d'activités",
      "button": "Ajouter à la liste",
      "validation": {
        "select_required": "Veuillez sélectionner une liste d'activités clés"
      }
    },
    "autocomplete": {
      "activity_list_label": "Liste d'activités",
      "no_project_associated": "Aucun projet associé"
    },
    "remove_from_list": {
      "confirm_content": "Cliquez sur confirmer pour supprimer cette activité de la liste actuelle, cette action ne supprimera pas l'activité."
    },
    "status": {
      "loading_aria": "chargement des activités clés",
      "more_activities_message": "Il y a plus d'activités clés que celles affichées."
    },
    "sync": {
      "stats_button": "Synchroniser les statistiques",
      "working_message": "Nous travaillons sur ceci, veuillez revenir dans quelques minutes et actualiser la page..."
    }
  },
  "warnings": {
    "maximum_contacts_selection": "Le maximum de contacts pour la sélection individuelle est de 100. Pour ajouter des contacts à une liste, veuillez réduire la sélection à 100 ou utiliser sélectionner tous les contacts."
  },
  "progress_tracker": {
    "my_contacts_title": "Mes contacts",
    "bulk_add_description": "Ajouter des contacts en lot à la liste"
  },
  "add_filtered_contacts": {
    "modal_header": "Ajouter un contact",
    "actions": {
      "add_contact": "Ajouter un contact",
      "add_new_contact": "Ajouter un nouveau contact",
      "new_contact": "Nouveau contact",
      "add_to_lists": "Ajouter aux listes({{count}})",
      "view_selected": "Voir la sélection",
      "clear_selection": "Effacer la sélection"
    },
    "filters": {
      "company_type": "Type d'entreprise",
      "relationship_partner": "Partenaire de relation",
      "known_by": "Connu par",
      "consent_status": "Statut de consentement",
      "key_activity": "Activité clé"
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "location": "Localisation",
        "last_interaction": "Dernière interaction"
      },
      "personal_contact": "-"
    },
    "bulk_add": {
      "success_message": "Demande envoyée. Cela peut prendre quelques minutes pour voir tous les contacts dans la liste cible"
    },
    "empty_state": "Aucun contact trouvé. Vérifiez vos filtres de recherche ou ajoutez un nouveau contact."
  },
  "blocked_contacts": {
    "modal_header": "Contacts exclus ou désabonnés ({{count}})",
    "modal_caption": "Les contacts n'ont pas été ajoutés en raison de règles d'exclusion ou de désabonnements. Veuillez vérifier avec l'administrateur pour plus de détails.",
    "view_contacts_not_added": "Voir les contacts non ajoutés"
  },
  "excluded_contacts": {
    "modal": {
      "title_excluded_unsubscribed": "Exclus/Désabonnés",
      "title_excluded": "Exclus",
      "caption_not_in_list": "Certains contacts n'ont pas été ajoutés en raison de règles d'exclusion ou de désabonnements. Vous ne pouvez modifier que les contacts de votre liste.",
      "caption_in_list": "{{count}} contacts correspondent aux règles d'exclusion. Mettez à jour leur statut pour les inclure, ou supprimez-les de cette liste marketing.",
      "view_contacts_not_added": "Voir les contacts non ajoutés"
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "exclusion_rules": "Règles d'exclusion"
      }
    },
    "reasons": {
      "user_unsubscribed": "Utilisateur désabonné",
      "company_blocked": "Entreprise bloquée",
      "contact_blocked": "Contact bloqué",
      "consent_status_unsubscribed": "Statut de consentement désabonné",
      "none": "Aucun",
      "reason": "Raison",
      "created_by": "Créé par",
      "field": "Champ"
    },
    "actions": {
      "save_and_add_to_list": "Sauvegarder et ajouter à la liste",
      "remove_from_list": "Supprimer de la liste",
      "toggle_details": "détails d'exclusion",
      "hide": "masquer",
      "show": "afficher"
    },
    "alerts": {
      "exclusion_rules_prevented": "Les règles d'exclusion ont empêché l'ajout de certains contacts.",
      "see_list_to_review": "Voir la liste pour révision."
    },
    "warnings": {
      "company_block_cannot_modify": "Ce contact a été exclu en raison d'un blocage d'entreprise et ne peut pas être modifié.",
      "no_permission_contact_admin": "Vous n'avez pas la permission de modifier les règles d'exclusion. Veuillez contacter l'administrateur pour plus de détails.",
      "no_permission_add_to_contacts": "Vous n'avez pas la permission de modifier les règles d'exclusion. Veuillez ajouter ce contact à Mes Contacts pour apporter des modifications."
    }
  },
  "list_membership": {
    "header": {
      "title": "Listes"
    },
    "empty": {
      "description": "Ce contact n’est dans aucune liste pour le moment. Cliquez sur le bouton ci-dessous pour commencer.",
      "marketing_redirect": "Pour la liste marketing, rendez-vous dans l’onglet Préférences Marketing."
    },
    "marketing": {
      "notice": "Ce contact fait partie d’une liste marketing.",
      "view_details": "Voir les détails"
    },
    "add_to_marketing_list": "Ajouter à la liste marketing",
    "unsubscribed": {
      "description_1": "Ce contact a été retiré de toutes les listes marketing.",
      "description_2": "Modifiez le statut de consentement ci-dessus pour activer la liste marketing sur ce contact."
    },
    "edit_consent": "Modifier le consentement",
    "marketing_empty": {
      "description": "Démarrez votre marketing en ajoutant des contacts à votre liste."
    },
    "icons": {
      "marketing": "liste marketing",
      "shared_contact_list": "liste de contacts partagée",
      "personal_contact_list": "liste de contacts personnelle",
      "project_contact_list": "liste de contacts de projet"
    }
  },
  "add_contact_to_list": {
    "errors": {
      "failed_to_create_contact": "Échec de la création de ce contact"
    },
    "validation": {
      "contact_required": "Le contact est requis"
    },
    "form": {
      "label_contact": "Contact",
      "placeholder_select_contact": "Quel contact souhaitez-vous fusionner",
      "submit": "Ajouter ce contact à la liste"
    }
  },
  "grid": {
    "columns": {
      "actions": "Actions",
      "contact": "Contact",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "open_tasks": "Tâches ouvertes",
      "last_updated": "Dernière mise à jour",
      "email": "Courriel",
      "job_title": "Titre du poste",
      "company": "Entreprise",
      "company_type": "Type d'entreprise",
      "contact_consent_status": "Statut de consentement du contact",
      "tags": "Tags",
      "last_interaction": "Dernière interaction",
      "added_datetime": "Date et heure d'ajout",
      "last_meeting": "Dernière réunion",
      "last_sent_email_at": "Dernier courriel envoyé le",
      "last_received_email_at": "Dernier courriel reçu le",
      "number_of_interactions": "Nombre d'interactions",
      "number_of_meetings": "Nombre de réunions",
      "number_of_sent_emails": "Nombre de courriels envoyés",
      "number_of_received_emails": "Nombre de courriels reçus",
      "number_of_total_emails": "Nombre total de courriels",
      "phone_numbers": "Numéros de téléphone",
      "linkedin_url": "URL LinkedIn",
      "twitter_url": "URL Twitter",
      "educations": "Formations",
      "company_tags": "Tags d'entreprise",
      "company_industry_names": "Noms d'industrie de l'entreprise",
      "company_internal_industry_names": "Noms d'industrie interne de l'entreprise",
      "company_website": "Site web de l'entreprise",
      "company_linkedin_url": "URL LinkedIn de l'entreprise",
      "company_twitter_url": "URL Twitter de l'entreprise",
      "company_correspondence_numbers": "Numéros de correspondance de l'entreprise",
      "company_correspondence_emails": "Courriels de correspondance de l'entreprise",
      "who_knows": "Qui connaît",
      "added_by": "Ajouté par",
      "contact_location": "Localisation du contact",
      "contact_street_address": "Adresse de rue du contact",
      "contact_city": "Ville du contact",
      "contact_state": "État du contact",
      "contact_postcode": "Code postal du contact",
      "contact_country": "Pays du contact",
      "contact_office_location": "Localisation du bureau du contact",
      "office_street_address": "Adresse de rue du bureau",
      "office_city": "Ville du bureau",
      "office_state": "État du bureau",
      "office_postcode": "Code postal du bureau",
      "office_country": "Pays du bureau",
      "company_client_id": "ID client de l'entreprise",
      "company_group_id": "ID de groupe de l'entreprise",
      "email_suffix": "(courriel)",
      "edit": "Modifier"
    }
  },
  "status": {
    "active": "Actif",
    "archived": "Archivé",
    "added": "Ajouté",
    "select_aria_label": "sélectionner le statut de la liste"
  },
  "contact_list_form": {
    "create_aria_label": "Créer une liste de contacts",
    "create_title": "Créer une liste de contacts",
    "create_button": "Créer une liste de contacts",
    "rename_header": "Renommer la liste",
    "new_header": "Nouvelle liste de contacts",
    "render_mode": {
      "default": {
        "title": "Défaut",
        "content": "Ajoutez jusqu'à 10 000 contacts. Recherche, tri et filtres étendus. Convient aux listes de prospect ou d'événements."
      },
      "advanced": {
        "title": "Avancé",
        "content": "Ajoutez un nombre illimité de contacts. Performances améliorées. Recherche, tri et filtres limités. Convient aux listes marketing."
      }
    },
    "name_label": "Nom",
    "name_placeholder": "Nom",
    "allow_duplicates_label": "Activer les contacts en double",
    "marketing_list_label": "Définir comme liste marketing"
  }
}
